import { Skeleton } from '@skin-seoul/design-system';

/** Matches the 120 × 152 compact product media and the separate text/price/review rows. */
export function CartSavedProductsSkeleton({ recommendations = false }: { recommendations?: boolean }) {
  return (
    <div
      role="status"
      aria-label="Loading products"
      aria-busy="true"
      className={`${recommendations ? '-mx-4 ' : ''}border-t-8 border-neutral-50 px-4 py-5`}
    >
      <div aria-hidden="true">
        <div className="mb-6 flex h-6 items-center justify-between">
          <Skeleton className="h-4 w-36 motion-reduce:animate-none" />
          {!recommendations && <Skeleton className="h-3 w-14 motion-reduce:animate-none" />}
        </div>
        <div className="flex gap-2.5 overflow-hidden pb-2">
          {[0, 1, 2, 3].map((index) => (
            <div key={index} className="w-[120px] shrink-0">
              <Skeleton className="h-[152px] w-full rounded-lg motion-reduce:animate-none" />
              <div className="mt-2 flex flex-col gap-1.5">
                <Skeleton className="h-3 w-3/5 motion-reduce:animate-none" />
                <Skeleton className="h-7 w-full motion-reduce:animate-none" />
                <Skeleton className="h-5 w-2/3 motion-reduce:animate-none" />
                <Skeleton className="h-3 w-1/2 motion-reduce:animate-none" />
                <Skeleton className="h-4 w-4/5 motion-reduce:animate-none" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
